export const homeItems = [
  {
    name: "Strona główna",
    routePath: "/",
  },
  {
    name: "Home 02",
    routePath: "/home_2",
  },
  {
    name: "Home 03",
    routePath: "/home_3",
  },
  {
    name: "Home 04",
    routePath: "/home_4",
  },
  {
    name: "Home 05",
    routePath: "/home_5",
  },
  {
    name: "Home 06",
    routePath: "/home_6",
  },
  {
    name: "Home 07",
    routePath: "/home_7",
  },
  {
    name: "Home 08",
    routePath: "/home_8",
  },
  {
    name: "Home 09",
    routePath: "/home_9",
  },
  {
    name: "Home 10",
    routePath: "/home_10",
  },
];
export const blogItems = [
  {
    name: "Blog List V1",
    routePath: "/blog-list-v1",
  },
  {
    name: "Blog List V2",
    routePath: "/blog-list-v2",
  },
  {
    name: "Blog Single",
    routePath: "/blog-details/1",
  },
];
export const pageItems = [
  {
    name: "404",
    routePath: "/404",
  },
  {
    name: "About",
    routePath: "/about",
  },
  {
    name: "Become Expert",
    routePath: "/become-expert",
  },
  {
    name: "Help Center",
    routePath: "/help-center",
  },
  {
    name: "Login",
    routePath: "/login",
  },
  {
    name: "Register",
    routePath: "/signup",
  },
  {
    name: "Terms",
    routePath: "/terms",
  },
  {
    name: "Invoice",
    routePath: "/invoice",
  },
];
export const dashboardItems = [
  {
    name: "Dashboard",
    routePath: "/dashboard/db-dashboard",
  },
  {
    name: "Booking History",
    routePath: "/dashboard/db-booking",
  },
  {
    name: "Wishlist",
    routePath: "/dashboard/db-wishlist",
  },
  {
    name: "Settings",
    routePath: "/dashboard/db-settings",
  },
  {
    name: "Vendor Dashboard",
    routePath: "/vendor-dashboard/dashboard",
  },
  {
    name: "Vendor Add Hotel",
    routePath: "/vendor-dashboard/add-hotel",
  },
  {
    name: "Vendor Booking",
    routePath: "/vendor-dashboard/booking",
  },
  {
    name: "Vendor Hotels",
    routePath: "/vendor-dashboard/hotels",
  },
  {
    name: "Vendor Recovery",
    routePath: "/vendor-dashboard/recovery",
  },
  {
    name: "Logout",
    routePath: "/login",
  },
];

export const categorieMegaMenuItems = [
  {
    id: 1,
    menuCol: [
      {
        id: 1,
        megaBanner: "https://images.unsplash.com/photo-1586729223498-2cc4a05d3858?q=80&w=1074&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        title: "7 dni w Palermo za 828.5 zł za osobę",
        btnText: "Zobacz okazję",
        btnRoute: "/tour-single/89843",
        menuItems: [
          {
            id: 1,
            title: "Zainspiruj się naszymi wyszukiwaniami:",
            menuList: [
              {
                name: "Romantyczny weekend",
                routePath: "/tour-list-v1?fromLocation=&destination=Francja&durationMin=1&durationMax=6&onlyWeekends=true&uniqueDestinations=false&searchType=&inspirationLabel=Romantyczny%20weekend",
              },
              {
                name: "Tydzień zwiedzania",
                routePath: "/tour-list-v1?fromLocation=&destination=&durationMin=6&durationMax=10&onlyWeekends=false&uniqueDestinations=true&searchType=&inspirationLabel=Tydzie%C5%84%20zwiedzania",
              },
              {
                name: "Tydzień wypoczynku",
                routePath: "/tour-list-v1?fromLocation=&destination=W%C5%82ochy&durationMin=6&durationMax=10&onlyWeekends=false&uniqueDestinations=false&searchType=&inspirationLabel=Tydzie%C5%84%20wypoczynku",
              },
              {
                name: "Weekendowy city break",
                routePath: "/tour-list-v1?fromLocation=&destination=&durationMin=3&durationMax=5&onlyWeekends=true&uniqueDestinations=true&searchType=&inspirationLabel=Weekendowy%20city%20break",
              },
              {
                name: "Najtaniej",
                routePath: "/tour-list-v1?fromLocation=&destination=&durationMin=1&durationMax=14&onlyWeekends=false&uniqueDestinations=true&searchType=pricePerDay&inspirationLabel=Najtaniej",
              },
              {
                name: "Last minute",
                routePath: "/tour-list-v1?fromLocation=&destination=&durationMin=1&durationMax=14&onlyWeekends=false&uniqueDestinations=true&searchType=pricePerDay&inspirationLabel=Last%20minute",
              },
            ],
          },
          // {
          //   id: 2,
          //   title: "Hotel Single",
          //   menuList: [
          //     {
          //       name: "Hotel Single v1",
          //       routePath: "/hotel-single-v1/5",
          //     },
          //     {
          //       name: "Hotel Single v2",
          //       routePath: "/hotel-single-v2/3",
          //     },
          //   ],
          // },
          // {
          //   id: 3,
          //   title: "Hotel Booking",
          //   menuList: [
          //     {
          //       name: "Booking Page",
          //       routePath: "/booking-page",
          //     },
          //   ],
          // },
        ],
      },
    ],
  }
];

export const categorieMobileItems = [
  {
    id: 1,
    title: "Nasze wyszukiwania",
    menuItems: [
      {
        id: 1,
        name: "Romantyczny weekend",
        routePath: "/tour-list-v1?fromLocation=&destination=Francja&durationMin=1&durationMax=6&onlyWeekends=true&uniqueDestinations=false&searchType=&inspirationLabel=Romantyczny%20weekend"
      },
      {
        id: 2,
        name: "Tydzień zwiedzania",
        routePath: "/tour-list-v1?fromLocation=&destination=&durationMin=6&durationMax=10&onlyWeekends=false&uniqueDestinations=true&searchType=&inspirationLabel=Tydzie%C5%84%20zwiedzania"
      },
      {
        id: 3,
        name: "Tydzień wypoczynku",
        routePath: "/tour-list-v1?fromLocation=&destination=W%C5%82ochy&durationMin=6&durationMax=10&onlyWeekends=false&uniqueDestinations=false&searchType=&inspirationLabel=Tydzie%C5%84%20wypoczynku"
      },
      {
        id: 4,
        name: "Weekendowy city break",
        routePath: "/tour-list-v1?fromLocation=&destination=&durationMin=3&durationMax=5&onlyWeekends=true&uniqueDestinations=true&searchType=&inspirationLabel=Weekendowy%20city%20break"
      },
      {
        id: 5,
        name: "Najtaniej",
        routePath: "/tour-list-v1?fromLocation=&destination=&durationMin=1&durationMax=14&onlyWeekends=false&uniqueDestinations=true&searchType=pricePerDay&inspirationLabel=Najtaniej"
      },
      {
        id: 6,
        name: "Last minute",
        routePath: "/tour-list-v1?fromLocation=&destination=&durationMin=1&durationMax=14&onlyWeekends=false&uniqueDestinations=true&searchType=pricePerDay&inspirationLabel=Last%20minute"
      }
    ]
  }
];
